
export const excludeProductEntries = data => ![
  "นิตยสารอะชีฟรูปแบบอิเล็กทรอนิกส์",
  "นิตยสารอะชีฟแบบรูปเล่ม",
  "ชุดสมัครสมาชิกแอมเวย์",
  "ชุดคู่มือนักธุรกิจแอมเวย์แบบอิเล็กทรอนิกส์",
].includes(data.product.name);
